import { Image, Flex, Text } from '@chakra-ui/react'
import Link from 'next/link'
import React from 'react'

const ActionCards = ({ title, img, body, route, func, profile, directRoute }) => {
    return (
        (<Flex width={{ base: "100%", sm: "30%" }} mb={{ base: "15px", sm: 0 }} borderWidth={"1px"} borderRadius={"4px"}>
            <Link href={(directRoute || profile) ? route : "#"} onClick={profile ? null : func}>

                <Flex flexDir={{ base: "row", sm: "column", md: "row" }} p={"15px"}>
                    <Flex rounded={"30px"} className={"imageBox"} bg={"brand.800"} mr={"15px"} w={{ base: "37px", lg: "40px" }} h={{ base: "37px", lg: "40px" }} alignItems={"center"} justifyContent={"center"}>
                        <Image src={img} width={{ base: "24px", lg: "24px" }} />
                    </Flex>

                    <Flex flexDir={"column"} mt={{ sm: "15px", md: 0 }}>
                        <Text color={"black.800"} fontSize={{ base: "18px", md: "14px", lg: "22px" }} fontWeight={500} fontStyle={"normal"} lineHeight={{ base: "28px", md: "18px", lg: "36px" }}>{title}</Text>
                        <Text color={"gray.500"} mt={"8px"} fontSize={{ base: "13px", md: "10px", lg: "15px" }} lineHeight={{ base: "23px", md: "16px", lg: "23px" }}>
                            {body}
                        </Text>
                    </Flex>
                </Flex>

            </Link >
        </Flex >)
    );
}

export { ActionCards }